export class HolidayConfiguration {
    id: number = 0;
    initialYear: number = 0;
    finalYear: number = 0;
    vacationDays: number = 0;
    percentage: number = 0;
}